import './index.scss'
import './list-style.scss'
import '../../assets/scss/tabs/index.scss'
import text from './text.json'
import modalText from '../../components/pages/resource/text.json'
import data from './data'
import Footer from '../../components/layouts/footer'
import {
    BarChartIcon,
    ColumnsIcon,
    DownIcon,
    EditIcon,
    FileNotFound,
    FilterIcon,
    GoodNewsIcon,
    HistoryIcon,
    HorizontalMoreIcon,
    InfoIcon,
    IntegrationIcon,
    PausedIcon,
    PlayIcon,
    PlusIcon,
    SearchIcon,
    TrashIcon,
    TrendingUpIcon,
    UpIcon
} from '../../icons'
import {ImgButton, SimpleBlueButton} from '../../components/core/button'
import {PageSubTitle, PageTitle} from '../../components/core/title'
import {useDispatch, useSelector} from 'react-redux'
import {
    deleteResources,
    getResources,
    getServices,
    setIsFirstLogin,
    setIsFirstResource,
    setModalIsActive,
    setPopUpIsActive,
    setResources,
    setSelectedResource,
    toggleResourcesStatus
} from '../../stores/resources'
import AddResourceModal from '../../components/pages/resource/AddResourceModal'
import EditResourceModal from '../../components/pages/resource/EditResourceModal'
import NotFound from './NotFound'
import {useEffect, useRef, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import InputWithIcon from '../../components/core/inputWithIcon'
import TextHelper from '../../utils/text'
import NavigationHelper from '../../utils/navigation'
import localStorageKeys from '../../utils/localStorageKeys'
import {routes} from '../../routes'
import ContentLoader from '../../components/core/loader'
import Confirm from '../../components/core/confirm'
import {setConfirmIsActive} from '../../stores/alert'
import ResponsivePageTitle from '../../components/core/title/ResponsivePageTitle'
import ButtonLoader from '../../components/core/button/ButtonLoader'
import {BlurBackground, TutorialActions} from '../../components/core/tutorial'
import Table from './../../components/core/table'
import localStorageManager from '../../utils/localStorageManager'
import {locationManager} from '../../utils/locations'
import Tooltip from '../../components/core/tooltip'
import classNames from 'classnames'
import Dropdown from '../../components/core/dropdown'
import CustomSelect from '../../components/core/customSelect'
import types from '../../data/monitoringTypes.json'
import Badge from '../../components/core/badge'
import {MenuDivider, MenuItem} from '@szhsin/react-menu'
import {setTeams} from '../../stores/teams'
import TeamSwitcher from '../../components/pages/teams'
import Customer from '../../utils/customer'
import ResourceSuggestion from './ResourceSuggestion'
import CustomerService from '../../api/customer'
import LimitManager from '../../utils/limitManager'
import {getSubscriptionPayments, getSubscriptions} from '../../stores/payment'
import TagManager from 'react-gtm-module'
import tagManager from '../../data/tagManager.json'
import AmountManager from '../../utils/amount'
import ListView from './ListView'
import {getAllResourcesStatisticsData} from '../../stores/monitoring'
import {colors} from '../../utils/colors'
import {sortBySelected} from '../../utils/sorting'
import {isResourceLimitEnabled} from '../../utils/limits'
import {isSelfHosted} from '../../utils/newFeature'
import IncidentsModal from '../../components/pages/ResourceIncidents'
import Modal from '../../components/core/modal'
import {getAllLimitUsages} from '../../stores/auth'

const typeOptions = Object.values(types).filter(item => !item?.hide_in_filter)

const viewOptions = {
    grid: {value: 'GRID'},
    list: {value: 'LIST'}
}

const MAX_TEXT_LENGTH = 21
const SORT_ID = 'uptime-monitoring-resources'

const InvalidResourceTooltip = ({resource}) => {
    if (resource?.is_invalid) {
        return <Tooltip content={text.invalid_host_text}>
            <InfoIcon width="24" height="24" color={colors.colorCoralRed}/>
        </Tooltip>
    }
    return null
}

export const ResourceUrl = ({resource}) => {
    const isHttp = resource?.type === types.http.value
    const url = isHttp ? resource?.url : resource?.host
    const className = classNames({
        'min-width': true,
        'text-muted': resource?.is_invalid
    })
    return !isHttp ? <span className={className} title={url}>
        {TextHelper.textLengthChecker(url, MAX_TEXT_LENGTH)}
    </span> : (
        <a className={className} title={url} href={url} target="_blank">
            {TextHelper.textLengthChecker(url, MAX_TEXT_LENGTH)}
        </a>
    )
}

export const ResourceName = ({resource, isListView = false}) => {
    return (
        <span className="min-width">
            <span className="d-flex align-items-center gap-1">
                <Link className={classNames({
                    underlined: !isListView,
                    'text-muted': resource?.is_invalid
                })}
                to={NavigationHelper.getNavigationUrl(routes.monitoring.path, ':id', resource?.resource_id)}>
                    {TextHelper.textLengthChecker(resource?.name, MAX_TEXT_LENGTH)}
                </Link>
                <InvalidResourceTooltip resource={resource}/>
                {!resource?.is_invalid && !resource?.enabled && <Tooltip content={text.paused}>
                    <PausedIcon stroke={colors.colorOrange}/>
                </Tooltip>}
            </span>
        </span>
    )
}

export const VisitButton = ({id, isDarkMode, handleModal}) => {
    const isFirstResource = useSelector(state => state.resources.isFirstResource)
    const dispatch = useDispatch()
    return (
        <>
            <Tooltip content={text.view_statistics}>
                <Link
                    to={NavigationHelper.getNavigationUrl(routes.monitoring.path, ':id', id)}
                    onClick={isFirstResource && dispatch(setIsFirstResource(false))}
                    className={classNames({
                        'table-action-btn': true,
                        'has-shadow': isFirstResource,
                        dark: isDarkMode
                    })}
                >
                    <TrendingUpIcon/>
                </Link>
            </Tooltip>
            <Tooltip content={text.incidents}>
                <span
                    onClick={() => handleModal(id)}
                    className={classNames({
                        'table-action-btn': true,
                        dark: isDarkMode
                    })}
                >
                    <HistoryIcon
                        fill={isDarkMode ? colors.colorFilterTitle : colors.colorMuted}
                    />
                </span>
            </Tooltip>
        </>
    )
}

export const IntegrationButton = ({id, navigate, isDarkMode}) => {
    return (
        <Dropdown menuButton={<button  className={classNames({
            'table-action-btn': true,
            dark: isDarkMode
        })}> <IntegrationIcon className="card-icon"/></button>}>
            <MenuItem onClick={() => navigate(routes.team_channels.path)}>
                <span>{text.team_channels}</span>
            </MenuItem>
            <MenuItem onClick={() => navigate(`${routes.notifications.path}`)}>
                <span>{text.personal_channels}</span>
            </MenuItem>
            {!isSelfHosted() && <MenuItem onClick={() => navigate(NavigationHelper.getNavigationUrl(routes.resource_integrations.path, ':id', id))}>
                <span>{text.integrations}</span>
            </MenuItem>}
        </Dropdown>
    )
}

export const ActionButton = ({data, setClickedResource, pauseMonitoring, playMonitoring, isDarkMode}) => {
    const dispatch = useDispatch()
    return <Dropdown menuButton={<button  className={classNames({
        'table-action-btn': true,
        dark: isDarkMode
    })}><HorizontalMoreIcon/></button>}>
        <MenuItem onClick={() => {
            setClickedResource(data)
            dispatch(setPopUpIsActive(true))
        }
        } disabled={data?.is_invalid || !isResourceLimitEnabled(data)}>
            <span className="d-flex"><EditIcon/></span>
            <span>{text.edit}</span>
        </MenuItem>
        <MenuItem disabled={data?.is_invalid || !data?.enabled} onClick={() => {
            pauseMonitoring([data?.resource_id])
        }
        }>
            <span className="d-flex"><PausedIcon/></span>
            <span>{text.pause}</span>
        </MenuItem>
        <MenuItem disabled={data?.is_invalid || data?.enabled || !isResourceLimitEnabled(data)} onClick={() => {
            playMonitoring([data?.resource_id])
        }
        }>
            <span className="d-flex"><PlayIcon/></span>
            <span>{text.monitor}</span>
        </MenuItem>
        <MenuDivider/>
        <MenuItem className="danger" onClick={() => {
            setClickedResource(data)
            dispatch(setConfirmIsActive(true))
        }
        }>
            <span className="d-flex"><TrashIcon stroke={colors.colorRed}/></span>
            <span>{text.delete}</span>
        </MenuItem>
    </Dropdown>
}

const Resources = () => {
    const services = useSelector(state => state.resources.services)
    const [selectedTabIndex, setSelectedTabIndex] = useState(-1)
    const [searchedText, setSearchedText] = useState('')
    const selectedResources = useSelector(state => state.resources.selectedResources)
    const modalIsActive = useSelector(state => state.resources.modalIsActive)
    const disableTutorial = useSelector(state => state.voucher.disableTutorial)
    const popUpIsActive = useSelector(state => state.resources.popUpIsActive)
    const resources = useSelector(state => state.resources.resources)
    const isDeleting = useSelector(state => state.resources.isDeleting)
    const isPausing = useSelector(state => state.resources.isPausing)
    const isMonitoring = useSelector(state => state.resources.isMonitoring)
    const isFetching = useSelector(state => state.resources.isFetching)
    const isFirstLogin = useSelector(state => state.resources.isFirstLogin)
    const isFirstResource = useSelector(state => state.resources.isFirstResource)
    const subscriptions = useSelector(state => state.payment.subscriptions)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const isTrialExpired = new Date(localStorageManager.get(localStorageKeys.TRIAL)?.expires) < new Date()
    const isTrialPeriod = LimitManager.isTrialPeriod()
    const gtmPurchaseInfo = useSelector(state => state.auth.gtmPurchaseInfo)
    const paymentData = useSelector(state => state.payment.paymentData)
    const [activeSubscription, setActiveSubscription] = useState({})
    const [suggestedResourceData, setSuggestedResourceData] = useState(null)
    const [selectedView, setSelectedView] = useState(localStorage.getItem(localStorageKeys.SELECTED_RESOURCE_VIEW) || viewOptions.grid.value)
    const [responseTimeData, setResponseTimeData] = useState([])

    const resource = resources?.find(item => item?.resource_id === selectedResources[0])
    const [clickedResource, setClickedResource] = useState(null)
    const [filteredResources, setFilteredResources] = useState([])
    const [isNotFound, setIsNotFound] = useState(false)
    const [activeIncidentModalId, setActiveIncidentModalId] = useState('')
    const [sortedResources, setSortedResources] = useState(resources)
    const initialFilter = {
        service_id: services,
        type: typeOptions
    }

    const dropdownMenuRef = useRef()

    const [filter, setFilter] = useState(initialFilter)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const DEFAULT_INDEX = -1
    const tableHeader = [
        {
            label: 'Resource name',
            className: 'min-width',
            sorting: {
                asc: {
                    key: 'name_asc',
                    field: ['name']
                },
                desc: {
                    key: 'name_desc',
                    field: ['name']
                }
            }
        },
        {
            label: 'Target',
            className: 'min-width',
            sorting: {
                asc: {
                    key: 'url_asc',
                    field: ['url']
                },
                desc: {
                    key: 'url_desc',
                    field: ['url']
                }
            }
        },
        {
            label: 'Type',
            className: 'min-width',
            sorting: {
                asc: {
                    key: 'type_asc',
                    field: ['type']
                },
                desc: {
                    key: 'type_desc',
                    field: ['type']
                }
            }
        },
        {
            label: 'State',
            className: 'min-width-400',
            sorting: {
                asc: {
                    key: 'state_asc',
                    field: ['state']
                },
                desc: {
                    key: 'state_desc',
                    field: ['state']
                }
            }
        }
    ]

    const tbodyData = []

    const openModal = () => {
        dispatch(setModalIsActive(true))
    }
    const openPopUp = () => {
        dispatch(setPopUpIsActive())
    }
    const pauseMonitoring = ids => {
        updateResourcesStatus(ids, {enabled: false})
    }
    const playMonitoring = ids => {
        updateResourcesStatus(ids, {enabled: true})
    }

    const getActionButtonsStatus = () => {
        if (selectedResources.length === 1 && resource?.is_invalid || selectedResources.length > 1 || selectedResources.length === 0 || !isResourceLimitEnabled(resource)) {
            return true
        }
    }

    const getPauseButtonStatus = () => {
        return resource?.is_invalid || !resource?.enabled || selectedResources?.length === 0 || filteredResources.filter(resource => selectedResources.includes(resource.resource_id))?.some(item => !item?.enabled)
    }
    const getPlayButtonStatus = () => {
        return (resource?.is_invalid || resource?.enabled || selectedResources?.length === 0 || filteredResources.filter(resource => selectedResources.includes(resource.resource_id))?.some(item => item?.enabled)) || !isResourceLimitEnabled(resource)
    }
    const isTextIncluded = resource => {
        return resource?.name?.toLowerCase().includes(searchedText) || resource?.url?.toLowerCase().includes(searchedText)
    }
    const searchResource = e => {
        setSearchedText(e.target.value.toLowerCase())
    }
    const changeTab = index => {
        setSelectedTabIndex(index)
        dispatch(setSelectedResource([]))
        setSearchedText('')
    }
    const generateTabMenu = () => {
        return (
            <div className={classNames('sections', {
                dark: isDarkMode
            })}>
                {data.tab_menu.map((item, index) => (
                    <span onClick={() => changeTab(item.index)}
                        className={classNames('section-text', {
                            active: item.index === selectedTabIndex,
                            dark: isDarkMode
                        })}
                        key={index}>{item.name}</span>
                ))}
            </div>
        )
    }
    const openDeleteResourceConfirm = () => {
        setClickedResource(null)
        dispatch(setConfirmIsActive(true))
    }
    const deleteResource = async() => {
        await dispatch(deleteResources(clickedResource ? [clickedResource?.resource_id] : selectedResources))
        setClickedResource(null)
    }
    const updateResourcesStatus = async(ids, data) => {
        await dispatch(toggleResourcesStatus(ids, data))
        setClickedResource(null)
    }

    const checkResourceState = (resource) => {
        return (
            <span className="resource-regions">
                {resource?.region_details?.map(item => (
                    <span className="resource-region" key={item?.region}>
                        <Tooltip content={locationManager.allRegions[item?.region]?.location}>
                            {locationManager.allRegions[item?.region]?.icon}
                        </Tooltip>
                        {resource?.enabled && (
                            <Tooltip content={TextHelper.getResourceState(item?.state, [text.up, text.down])}>
                                {TextHelper.getResourceState(item?.state, [<UpIcon/>, <DownIcon/>])}
                            </Tooltip>
                        )}
                    </span>
                ))}
            </span>
        )
    }

    const getResourceType = type => {
        if (type === types.icmp.value) {
            return <Badge className="lowercase" color={types[type]?.color}>{types.icmp.lowercase_label}</Badge>
        }
        return <Badge className="lowercase" color={types[type]?.color}>{type}</Badge>
    }

    const getNotFoundComponent = () => {
        return selectedTabIndex === DEFAULT_INDEX ?
            <NotFound message={text.resources_not_found} icon={<FileNotFound/>}/>
            : (
                selectedTabIndex === 0 ? <NotFound message={text.no_down_resource} icon={<GoodNewsIcon className="good-news-icon"/>}/> :
                    <NotFound message={text.resource_not_found} icon={<FileNotFound/>}/>
            )
    }
    const getActionButtonIcon = (condition, icon) => {
        return condition ? <ButtonLoader/> : icon
    }

    const searchByFilter = async(reset = false) => {
        dropdownMenuRef?.current?.closeMenu()
        if (reset) {
            setFilter(initialFilter)
            setFilteredResources(resources)
            setIsNotFound(resources?.length === 0)
            return
        }
        setSearchedText('')
        const serviceId = filter.service_id.map(item => item.value)
        const types = filter.type.map(item => item.value)

        if (!serviceId.length || !types.length) {
            const data = resources?.filter(item => serviceId.includes(item.service_id) || types.includes(item.type))
            setFilteredResources(data)
            setIsNotFound(data?.length === 0)
            return
        }
        const data = resources?.filter(item => serviceId.includes(item.service_id) && types.includes(item.type))
        setFilteredResources(data)
        setIsNotFound(data?.length === 0)
    }

    const handleChangeFilter = (name, value) => {
        setFilter(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const handleResourceSuggestionOpen = (resourceData) => {
        setSuggestedResourceData(resourceData)
        if (isFirstLogin) changeStep()
        else openModal()
    }

    const generateResources = () => {
        let data = getResourcesByState()

        return (
            <>
                <div className="search-filter-actions">
                    <div  className={classNames('search-actions', {
                        dark: isDarkMode
                    })}>
                        <InputWithIcon placeholder={text.search}
                            icon={<SearchIcon/>}
                            onChange={searchResource}
                            value={searchedText}
                            type="text"/>
                        <Dropdown closeMenu={true}
                            menuButton={
                                <button className="filter-button">
                                    <FilterIcon/>
                                    {text.filters}
                                </button>
                            } innerRef={dropdownMenuRef}>
                            <CustomSelect options={services} value={filter.service_id} name="service_id"
                                placeholder={text.select_service}
                                isMulti isClearable={false}
                                onChange={(name, value) => handleChangeFilter(name, value)}/>
                            <CustomSelect options={typeOptions} value={filter.type}
                                placeholder={text.select_type}
                                isMulti isClearable={false} name="type"
                                onChange={(name, value) => handleChangeFilter(name, value)}/>
                            <div className="d-flex w-100 justify-content-between gap-1">
                                <SimpleBlueButton className="outline w-100"
                                    onClick={() => searchByFilter(true)}>{text.reset}</SimpleBlueButton>
                                <SimpleBlueButton className="w-100"
                                    onClick={() => searchByFilter()}>{text.search}</SimpleBlueButton>
                            </div>
                        </Dropdown>
                    </div>
                    {Customer.isOwnTeam() && (
                        <div className="selected-actions">
                            <ImgButton onClick={openModal}
                                className={`responsive-add-button ${isFirstLogin && !modalIsActive ? 'has-shadow' : ''}`}>
                                <span><PlusIcon/></span>
                            </ImgButton>
                            <ImgButton className={classNames({
                                'light-bg': !isDarkMode
                            })}  disabled={getActionButtonsStatus()} onClick={openPopUp}>
                                <span><EditIcon/></span>
                                <span className="button-text">{text.edit}</span>
                            </ImgButton>
                            <ImgButton className={classNames({
                                'light-bg': !isDarkMode
                            })}  disabled={getPauseButtonStatus()}
                            onClick={() => pauseMonitoring(selectedResources)}>
                                <span>
                                    {getActionButtonIcon(isPausing, <PausedIcon/>)}
                                </span>
                                <span className="button-text">{text.pause}</span>
                            </ImgButton>
                            <ImgButton className={classNames({
                                'light-bg': !isDarkMode
                            })}  disabled={getPlayButtonStatus()}
                            onClick={() => playMonitoring(selectedResources)}>
                                <span>
                                    {getActionButtonIcon(isMonitoring, <PlayIcon/>)}
                                </span>
                                <span className="button-text">{text.monitor}</span>
                            </ImgButton>
                            <ImgButton className={classNames('outline-red', {
                                'light-bg': !isDarkMode
                            })}  disabled={selectedResources.length === 0}
                            onClick={openDeleteResourceConfirm}>
                                <span><TrashIcon stroke={colors.colorRed}/></span>
                                <span className="button-text">{text.delete}</span>
                            </ImgButton>
                        </div>
                    )}
                </div>
                {data.some(resource => isTextIncluded(resource)) && !isNotFound ? (
                    selectedView === viewOptions.grid.value ? <div className="content-body">
                        <Table
                            tableHeader={tableHeader}
                            tbodyData={tbodyData}
                            identificator='resource_id'
                            inputName='resource'
                            hasCheckbox={Customer.isOwnTeam()}
                            data={sortedResources}
                            isMultiCheckable={true}
                            selectedData={selectedResources}
                            setSelectedData={data => dispatch(setSelectedResource(data))}
                            isSortingEnabled
                            setData={setSortedResources}
                            sortId={SORT_ID}
                            strech
                            filteredData={filteredResources}
                        />
                    </div> : <ListView
                        data={sortedResources}
                        selectedData={selectedResources}
                        setSelectedData={data => dispatch(setSelectedResource(data))}
                        responseTimeData={responseTimeData}
                        isDarkMode={isDarkMode}
                        handleModal={handleActiveIncidentModal}
                    />
                ) : (
                    getNotFoundComponent()
                )}
            </>
        )
    }
    const getBody = () => {
        return (
            <>
                {isFetching ? (
                    <ContentLoader/>
                ) : (
                    <>
                        {resources?.length > 0 ? (
                            <>
                                <TeamSwitcher/>
                                <div className="change-view">
                                    {generateTabMenu()}
                                    <div className="view-buttons">
                                        <p>{text.view}</p>
                                        <button className={classNames({
                                            'active': viewIsActive(viewOptions.grid.value)
                                        })} onClick={() => toggleView(viewOptions.grid.value)}>
                                            <ColumnsIcon/>
                                        </button>
                                        <button className={classNames({
                                            'active': viewIsActive(viewOptions.list.value)
                                        })} onClick={() => toggleView(viewOptions.list.value)}>
                                            <BarChartIcon/>
                                        </button>
                                    </div>
                                </div>
                                {generateResources()}
                                {(popUpIsActive && selectedView === viewOptions.grid.value) && (
                                    <EditResourceModal
                                        closeModal={() => {
                                            setClickedResource(null)
                                            dispatch(setPopUpIsActive(false))
                                        }}
                                        title={modalText.edit_resource} isOpen={popUpIsActive}
                                        contentClassName="overflow-auto"
                                        setClickedResource={setClickedResource}
                                        resource={clickedResource || resources?.find(item => item?.resource_id === selectedResources[0])}/>
                                )}
                            </>
                        ) : (
                            <>
                                <TeamSwitcher/>
                                <ResourceSuggestion shouldButtonHighlight={isFirstLogin && !modalIsActive}
                                    onAddResource={handleResourceSuggestionOpen} isDarkMode={isDarkMode}/>
                            </>
                        )}
                    </>
                )}
            </>
        )
    }
    const tutorialActions = [
        {
            text: text.tutorial_add_resource_desc,
            callBack: () => openModal()
        },
        {
            text: text.tutorial_fill_resource_infos_desc,
            callBack: () => dispatch(setIsFirstLogin(false))
        }
    ]

    const resourceTutorialCallback = () => {
        navigate(NavigationHelper.getNavigationUrl(routes.monitoring.path, ':id', resources[0]?.resource_id))
        dispatch(setIsFirstResource(false))
    }

    const monitoringTutorial = [
        {
            text: text.tutorial_see_statistics_desc,
            callBack: () => resourceTutorialCallback()
        }
    ]
    const changeStep = () => {
        document.querySelector('#next-btn').click()
    }

    const skipCallback = () => {
        dispatch(setIsFirstResource(false))
        localStorage.removeItem(localStorageKeys.NO_RESOURCE_CREATED_KEY)
    }

    const getResourcesByState = () => {
        return selectedTabIndex !== -1 ? resources.filter(item => item?.state === selectedTabIndex) : resources
    }

    const getAllResourcesStatistics = async() => {
        setResponseTimeData(await dispatch(getAllResourcesStatisticsData(filteredResources)))
    }

    const handleActiveIncidentModal = (id) => {
        setActiveIncidentModalId(activeIncidentModalId === id ? '' : id)
    }

    useEffect(() => {
        dispatch(getAllLimitUsages())
    }, [])

    useEffect(() => {
        setSortedResources(sortBySelected(filteredResources, SORT_ID, tableHeader))
    }, [filteredResources])

    useEffect(() => {
        if (selectedView === viewOptions.list.value && !responseTimeData?.length) {
            getAllResourcesStatistics()
        }
    }, [filteredResources, selectedView])

    useEffect(() => {
        if (services?.length) {
            dispatch(getResources(true))
            setFilter(prev => ({
                ...prev,
                service_id: services
            }))
        }
        dispatch(setSelectedResource([]))
    }, [services])

    useEffect(() => {
        setFilteredResources(resources)
        localStorageManager.get(localStorageKeys.SHOW_TUTORIALS_AFTER_PAYMENT) && dispatch(setIsFirstLogin(true))
        localStorage.removeItem(localStorageKeys.SHOW_TUTORIALS_AFTER_PAYMENT)
        const interval = setInterval(() => {
            dispatch(getResources())
        }, process.env.REACT_APP_RESOURCES_UPDATE_TIME)
        return () => clearInterval(interval)
    }, [resources])

    useEffect(() => {
        setFilteredResources(getResourcesByState())
    }, [selectedTabIndex, resources])

    useEffect(() => {
        let data = getResourcesByState()
        setFilteredResources(data?.filter(resource => resource?.name?.toLowerCase().includes(searchedText) || resource?.url?.toLowerCase().includes(searchedText)))
    }, [searchedText])

    useEffect(() => {
        setActiveSubscription(subscriptions?.data?.subscriptions?.find(item => item?.active === true))
    }, [subscriptions])

    useEffect(() => {
        activeSubscription?.subscription_id && dispatch(getSubscriptionPayments(activeSubscription?.subscription_id))
    }, [activeSubscription])

    useEffect(() => {
        if (isTrialPeriod && isTrialExpired && !gtmPurchaseInfo && Object.values(paymentData).length > 0) {
            CustomerService.setPurchaseInfo()
            TagManager.dataLayer({
                dataLayer: {
                    event: tagManager.events.purchase,
                    ecommerce: {
                        transaction_id: activeSubscription?.subscription_id,
                        value: AmountManager.normalizePrice(paymentData?.data?.subscription?.payments[0]?.paid_amount),
                        tax: 0,
                        currency: paymentData?.data?.subscription?.payments[0]?.currency.toUpperCase(),
                        items: [
                            {
                                item_name: paymentData?.data?.subscription?.plan,
                                price: AmountManager.normalizePrice(paymentData?.data?.subscription?.payments[0]?.paid_amount),
                                quantity: 1
                            }
                        ]
                    }
                }
            })
        }
    }, [JSON.stringify(paymentData)])

    useEffect(() => {
        !isSelfHosted() && dispatch(getSubscriptions())
        dispatch(setModalIsActive(false))
        return () => {
            dispatch(setResources([]))
            dispatch(setTeams([]))
            dispatch(getServices())
        }
    }, [])

    sortedResources?.forEach((resource, index) => {
        tbodyData.push([
            <ResourceName resource={resource}/>,
            <ResourceUrl resource={resource}/>,
            <div className={classNames({
                'd-flex': true,
                'align-items-center gap-half min-width': true,
                'text-muted': resource?.is_invalid
            })}>
                <span>{getResourceType(resource?.type)}</span>
                {resource?.is_advanced && <span><Badge className="lowercase" color="primary">{text.advanced}</Badge></span>}
            </div>,
            <span className="d-flex justify-content-between min-width-400">
                {checkResourceState(resource)}
                <span className="d-flex align-items-center gap-half">
                    <VisitButton id={resource?.resource_id} isDarkMode={isDarkMode} handleModal={handleActiveIncidentModal}/>
                    {Customer.isOwnTeam() && <>
                        <IntegrationButton id={resource?.resource_id} navigate={navigate} isDarkMode={isDarkMode}/>
                        <ActionButton data={resource} setClickedResource={setClickedResource}
                            playMonitoring={playMonitoring} pauseMonitoring={pauseMonitoring} isDarkMode={isDarkMode}/>
                    </>}
                </span>
            </span>
        ])
    })

    const handleCloseAddResourceModal = () => {
        dispatch(setModalIsActive(false))
        setSuggestedResourceData(null)
    }

    const toggleView = value => {
        localStorage.setItem(localStorageKeys.SELECTED_RESOURCE_VIEW, value)
        setSelectedView(value)
    }

    const viewIsActive = value => {
        return selectedView === value
    }

    const activeResource = resources?.find(
        (r) => r?.resource_id === activeIncidentModalId
    )

    return (
        <>
            {(isFirstLogin && !disableTutorial) &&
                <>
                    <BlurBackground/>
                    <TutorialActions actions={tutorialActions}
                        skipCallback={() => dispatch(setIsFirstLogin(false))}/>
                </>
            }

            {isFirstResource &&
                <>
                    <BlurBackground/>
                    <TutorialActions actions={monitoringTutorial} skipCallback={skipCallback}/>
                </>
            }
            <main className={classNames('main resources', {
                dark: isDarkMode
            })}>
                {activeIncidentModalId && (
                    <Modal
                        isOpen={activeIncidentModalId}
                        contentClassName="overflow-auto"
                        id="incidents-modal"
                        title={text.incidents}
                        closeModal={() => handleActiveIncidentModal(activeIncidentModalId)}
                    >
                        <span className='incident-modal-sub-title'>
                            <Tooltip content={text.view_statistics}>
                                <Link
                                    to={NavigationHelper.getNavigationUrl(routes.monitoring.path, ':id', activeIncidentModalId)}
                                    className={classNames({
                                        'table-action-btn': true,
                                        dark: isDarkMode
                                    })}
                                >
                                    <TrendingUpIcon/>
                                </Link>
                            </Tooltip>
                            <p className='incident-modal-sub-title-text'>{activeResource?.name}</p>
                        </span>
                        <IncidentsModal
                            resourceId={activeIncidentModalId}
                            resourceType="Resource"
                        />
                    </Modal>
                )}

                <Confirm
                    body={text.are_you_sure}
                    callback={deleteResource} showLoader={isDeleting}/>
                <div>
                    <ResponsivePageTitle/>
                    <div className="content-title">
                        <div className="left-side">
                            <div>
                                <PageSubTitle>
                                    <p className={classNames('section', {
                                        dark: isDarkMode
                                    })}>{text.section}</p>
                                </PageSubTitle>
                                <PageTitle>
                                    <h1  className={classNames('page-title', {
                                        dark: isDarkMode
                                    })}>{text.title}</h1>
                                </PageTitle>
                            </div>
                        </div>
                        {Customer.isOwnTeam() && !!resources?.length && (
                            <ImgButton onClick={openModal}>
                                {text.add_resource}
                                <span><PlusIcon/></span>
                            </ImgButton>
                        )}
                    </div>
                    {getBody()}
                </div>
                <Footer/>
            </main>
            {modalIsActive &&
                <AddResourceModal
                    contentClassName="overflow-auto" title={text.add_new_resource} isOpen={modalIsActive}
                    closeModal={handleCloseAddResourceModal} className={classNames({
                        'inside-blur-background has-shadow': isFirstLogin
                    })} defaultResourceData={suggestedResourceData}
                />
            }
        </>
    )
}

export default Resources
